export default {
  en: {
    'stadium_terrace_expansion': 'stadium terrace expansion',
    'stadium_foundation_expansion': 'stadium foundation expansion',
    'stadium': 'stadium',
    'target_seats': 'seats: {seats}',
    'entrance_fee': 'entrance fee',
    'development_ongoing_until_x': 'development ongoing until {date}',
    'are_you_sure_want_to_develop_the_foundation?': 'Are you sure want to develop the foundation?',
    'increase_spectators_popularity': 'increase spectators popularity',
    'increase_cost_for_terrace_seats': 'increase cost for terrace seats',
    'done': 'done',
    'expand': 'expand',
    'new_capacity': 'new capacity',
    'the_current_seat_capacity_will_not_be_available_during_expansion': 'The current seat capacity will not be available during expansion.',
    'seats_x': 'seats: {seats}',
    'seats_when_finished_x': 'when finished: {seats}',
    'spectators_x_of_total': 'spectators: {seats} / {capacity}',
    'sold_out': 'sold out',
    'total': 'total',
    'foundation': 'foundation',
    'terraces': 'terraces',
    'block_north_west': 'north-west',
    'block_north': 'north',
    'block_north_east': 'north-east',
    'block_east': 'east',
    'block_south_east': 'south-east',
    'block_south': 'south',
    'block_south_west': 'south-west',
    'block_west': 'west',
    'increased_terrace_seat_limits': 'increased terrace seat limits',
    '': '',
  }
};
